import styled from 'styled-components';

const Custom404TemplateStyle = styled.section`
	--distance: var(--sp6x);
	--svgW: var(--sp30x);
	--svgH: var(--sp13x);

    height: calc(100vh - var(--headerFixedHeight));
	position: relative;

	.error-container {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.main-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.title {
		margin: var(--distance) 0 var(--distance);
	}

	.btn {
		margin-top: var(--distance);
	}

	.error-svg {
		svg {
			width: var(--svgW);
			height: var(--svgH);
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeL}) {
		--distance: var(--sp5x);
		--svgW: var(--sp25x);
		--svgH: var(--sp11x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeM}) {
		--distance: var(--sp4x);
		--svgW: var(--sp20x);
		--svgH: var(--sp9x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.desktopSizeS}) {
		--distance: var(--sp3x);
		--svgW: var(--sp15x);
		--svgH: var(--sp7x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSize}) {
	}

	//! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--svgW: var(--sp13x);
		--svgH: var(--sp6x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) and (min-width: ${(props) => props.theme.mediaQuery.tabletSizeS}) {
		--distance: var(--sp2x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default Custom404TemplateStyle;
